import { render, staticRenderFns } from "./single-view-wrapper.vue?vue&type=template&id=576179b3&scoped=true&"
import script from "./single-view-wrapper.vue?vue&type=script&lang=js&"
export * from "./single-view-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./single-view-wrapper.vue?vue&type=style&index=0&id=576179b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576179b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VDivider,VRow})
